import { useIntl } from 'react-intl';
import { useQuery } from '@apollo/client/react';
import { type MyBudgetQuery, MyBudgetDocument } from 'graphql/generated/graphql';

const useMyBudget = (): [MyBudgetQuery['myBudget'] | undefined, boolean] => {
  const { locale } = useIntl();
  const { data, loading } = useQuery(MyBudgetDocument, { variables: { locale } });

  return [data?.myBudget, loading];
};

export default useMyBudget;
